import React, { useState,useRef } from 'react';
import {InpDataList,useClientSearch} from '@gull'
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios'
import swal from "sweetalert2";
import ClientDetails from './ClientDetails'

const FusionClientForm = (props) =>{
    const t = useTranslate();
    // Recherche client côté serveur (debounce + résultats plafonnés)
    const clientSearch = useClientSearch(() => swal.fire(t('unknowError'), "", "error"))
    const [clientId,setClientId]=useState(false)
    const [valueInputClient,setValueInputClient]=useState('')
    const dataListDropClient = useRef('')
    const [validButton,setValidButton]=useState() 
    const [success,setSuccess] = useState(false)

    const [loading,setLoading]=useState(false) 
    const [infoClient,setInfoClient]=useState(false) 

    const handleReset = () =>{
        setClientId(false)
        setValueInputClient('')
        setInfoClient(false)
    }
    
    
    /**
     * Gère la saisie : la recherche part (après debounce) sur le terme complet.
     */
    const handleSearch = (e) => {
        setValueInputClient(e.target.value)
        if(clientSearch.onInput(e.target.value)){
            dataListDropClient.current.classList.remove("d-none");
        }else{
            dataListDropClient.current.classList.add("d-none");
        }
    }

    const handleCLick = async (id,valeur) => {
        setValueInputClient(valeur)
        dataListDropClient.current.classList.add("d-none");
        clientSearch.reset()
        setClientId(id)
        setLoading(true)

        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/fidelite/get_fidelite_client/"+id
        ).then((response) => {
            let obj = {...response.data.client,total_point_fidelite_client:response.data.total_point_fidelite_client}
            setInfoClient(obj)
            setLoading(false)
        }).catch((error) => {
            if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }
                else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }
                else {
                    messageError='unknowError'
                }
                
                swal.fire(messageError, "", "error");
            setLoading(false)
        })
    }

    const mergeCustomer = async () =>{
        if(clientId){
            setValidButton(true)
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/client/fusion_client/"+props.currentClient+"/"+clientId
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach((interm)=>{
                        let finalMessage=interm.split('/!');
                        if(finalMessage.length==2){
                            messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                        }
                        else{
                            messageError+=t(interm)+'<br/>'
                        }
                    })
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }else{
                    setSuccess(true)
                    handleReset()
                    props.setShowFusion(false)
                    props.setRelance(Date.now())
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError = (error.response==undefined) ? t('unknowError') : (error.response.status==403) ? t('forbiddenGeneral') : t('unknowError');
                swal.fire(messageError, "", "error");
            })
            setValidButton(false)
            setTimeout(()=>{
                setSuccess(false)
            },1000)
        }else{
            swal.fire(t('allFieldsRequired'), "", "error");
        }
    }

    return (
        <div>
            
            <div className="row mb-2 d-flex justify-content-center align-items-center">
                <div className="col-10">
                    <div className='alert alert-info mb-2'>{t('fusionClientInfo',{clientName: props.client.name+' '+props.client.firstname})}</div>
                </div>
                <div className="col-8 position-relative">
                    <div className='form-group'>
                        <label>{t('selectCustomer')+' :'}</label>
                        <InpDataList
                            placeholder={t('customerPlacehlder')}
                            value={valueInputClient}
                            onClick={handleCLick}
                            onChange={handleSearch}
                            datas={clientSearch.datas}
                            footer={clientSearch.footer}
                            declenchement={3}
                            listRef={dataListDropClient}
                        />
                    </div>
                    {(clientSearch.loading) ? <span><div className="spinner-border spinner-border-sm erpGiftCardPosition"></div></span> : false }
                </div>
                <div className='col-2'>
                    <button disabled={validButton} className="btn btn-sm btn-warning" onClick={()=>handleReset('reset')}>
                        Reset
                    </button>&nbsp;&nbsp;
                    <button disabled={validButton} className="btn btn-sm btn-primary" onClick={()=>mergeCustomer()}>
                        {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                    </button>
                </div>
                <div className="col-10">
                    {(success) ? <div className="alert alert-success mt-3">{t('successOperation')}</div> : false}
                </div>
            </div>
            {(loading) ?
                <span className='d-flex justify-content-center mt-2'><div className="spinner-border spinner-border-sm"></div></span>
            :
                infoClient ?
                    <ClientDetails client={infoClient}/>
                :
                    false
            }
        </div>
    )
};

export default FusionClientForm;